import React from "react";
import { Box, Typography, Button } from "../../ui-kit";
import { useStyles } from "./RejectionPanel.styles";
import { RejectionReason } from "../../redux/onBoardingSlice.types";
import { ONBOARDING_TEXT } from "../text.constants";

export interface RejectionPanelProps {
  reasons?: RejectionReason[];
  selectedReason: string;
  onSelect: (key: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
  className?: string;
}

const RejectionPanel = ({
  reasons = [],
  selectedReason,
  onSelect,
  onCancel,
  onConfirm,
  className,
}: RejectionPanelProps) => {
  const classes = useStyles();

  const confirmDisabled = !selectedReason;

  return (
    <Box className={`${classes.wrap}${className ? ` ${className}` : ""}`}>
      <Box className={classes.panel}>
        {reasons.map((reason) => {
          const selected = selectedReason === reason.key;
          return (
            <Box
              key={reason.key}
              className={classes.radioRow}
              onClick={() => onSelect(reason.key)}
            >
              <span className={`${classes.radioCircle}${selected ? ` ${classes.radioCircleSelected}` : ""}`}>
                {selected && <span className={classes.radioDot} />}
              </span>
              <Typography className={classes.radioLabel}>{reason.value}</Typography>
            </Box>
          );
        })}
      </Box>

      <Box className={classes.actions}>
        <Button variant="outlined" className={classes.cancelBtn} onClick={onCancel} disableElevation>
          {ONBOARDING_TEXT.REJECTION_CANCEL_BTN}
        </Button>
        <Button
          variant="contained"
          className={classes.confirmBtn}
          onClick={onConfirm}
          disabled={confirmDisabled}
          disableElevation
        >
          {ONBOARDING_TEXT.REJECTION_CONFIRM_BTN}
        </Button>
      </Box>
    </Box>
  );
};

export default RejectionPanel;
